import { render, staticRenderFns } from "./ContestacoesWebcheckout.vue?vue&type=template&id=df0612b2&scoped=true&"
import script from "./ContestacoesWebcheckout.vue?vue&type=script&lang=js&"
export * from "./ContestacoesWebcheckout.vue?vue&type=script&lang=js&"
import style0 from "./ContestacoesWebcheckout.vue?vue&type=style&index=0&id=df0612b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0612b2",
  null
  
)

export default component.exports